import React, { Suspense, useEffect } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import './styles/styles.scss'
import { AuthProvider } from './auth'
import AuthConsumer from './auth/auth-consumer'
import SplashScreen from './components/splash-screen/splash-screen'
import { useDispatch, useSelector } from 'react-redux'
import { setDisplayMessage, setRouteToNavigate } from './redux/slices/login.slice'
import { ToastMessage } from './sharedComponent/toastMessage'
import { ThemeProvider } from './components/ThemeContext'
import NavigationListener from './NavigationListener'
import UserProfileRoute from './UserProfileRoute'

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
// Pages
const Login = React.lazy(() => import('./views/pages/login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

const App = () => {
  const dispatch = useDispatch()
  const { displayMessage } = useSelector((state) => state.login)

  useEffect(() => {
    const href = window.location.href
    if (href.endsWith('?route=rfx')) {
      const h = href.toString().split('/#')
      const url = href.toString().split('/#').pop().slice(0, -10)
      dispatch(setRouteToNavigate(url))
      const navURL = h[0] + '/#' + url
      window.location.href = navURL
    }

    dispatch(setDisplayMessage(null))
  }, [dispatch])

  return (
    <HashRouter>
      <UserProfileRoute />
      <NavigationListener />
      <div className="position-fixed top-0 w-100 vh-100 overflow-auto">
        <ToastMessage {...displayMessage} />

        <AuthProvider>
          <AuthConsumer>
            <ThemeProvider>
              <Suspense fallback={<SplashScreen />}>
                <Routes>
                  <Route exact path="/" name="Login Page" element={<Login />} />
                  <Route exact path="/register" name="Register Page" element={<Register />} />
                  <Route exact path="/404" name="Page 404" element={<Page404 />} />
                  <Route exact path="/500" name="Page 500" element={<Page500 />} />
                  <Route path="*" name="Home" element={<DefaultLayout />} />
                </Routes>
              </Suspense>
            </ThemeProvider>
          </AuthConsumer>
        </AuthProvider>
      </div>
    </HashRouter>
  )
}

export default App
